import { render } from "./FormEdit.vue?vue&type=template&id=5657bc41&scoped=true&ts=true"
import script from "./FormEdit.vue?vue&type=script&lang=ts"
export * from "./FormEdit.vue?vue&type=script&lang=ts"

import "./FormEdit.vue?vue&type=style&index=0&id=5657bc41&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5657bc41"]])

export default __exports__